import $ from 'jquery';
import 'slick-carousel';

const defaults = {
  speed: 250,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
      },
    },
  ],
};

export default class Slider {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign(defaults, options);
    this.slider = this.addSlider();
    this.ready();
  }

  addSlider() {
    return this.$element.find('.view-content').slick(this.settings);
  }

  ready() {
    this.$element.addClass('ready');
  }
}
